<template>
    <div>
        <table-actions-menu
            position="table-action-menu--low"
            :width="currentUser.isAdmin() ? 'table-action-menu--default-width':'table-action-menu--only-one'"
            >
            <edit-button
                :url="route('tenant.clients.courses.edit', {'client': clientId, 'course': data.id})"
                grid="table-action-cell--grid-1of3"
                v-if="currentUser.isAdmin()"
            >
            </edit-button>

            <delete-button
                :url="route('tenantapi.clients.unassign', {'client' : clientId, 'course': data.id})"
                :confirmTitle="trans('clients.note.unassign_title')"
                :confirmText="trans('clients.note.unassign_message')"
                :errorFlashMessage="trans('clients.flash.not_deleted')"
                :deleteId="data.id"
                grid="table-action-cell--grid-1of3"
                v-if="currentUser.isAdmin()"
            ></delete-button>

            <link-table-action-button
                :url="route('tenant.clients.courses.additional-course-content', {'client': clientId, 'course': data.id})"
                :label="trans('clients.label.additional_content')"
                :grid="currentUser.isAdmin() ? 'table-action-cell--grid-1of3':'table-action-cell--grid-1of1'"
            >
                <inline-svg
                    :url="require('../../../../images/actions/course.svg')"
                    classes="table-action-cell__icon"
                >
                </inline-svg>
            </link-table-action-button>
        </table-actions-menu>
    </div>
</template>

<script>
    import InlineSvg from '../../../util/inlineSvg.js'
    import EditButton from '../../table_actions/table_actions_buttons/EditButton.vue';
    import DeleteButton from '../../table_actions/table_actions_buttons/DeleteButton.vue';

    export default {
        props: ['data', 'index', 'clientId'],

        components: {
            EditButton,
            DeleteButton,
            InlineSvg
        },
    }
</script>
